// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent overlay */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: #ffffff;
    padding: 20px 30px;
    border-radius: 8px;
    width: 400px;
    text-align: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.modal-content h2 {
    font-size: 20px;
    color: #FF0000;
    margin-bottom: 10px;
}

.modal-content p {
    font-size: 16px;
    color: #4B5563;
    margin-bottom: 20px;
}

.confirm-button {
    padding: 10px 20px;
    background-color: #FF0000;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 10px;
}

.cancel-button {
    padding: 10px 20px;
    background-color: #CCCCCC;
    color: black;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.confirm-button:hover {
    background-color: #E60000;
}

.cancel-button:hover {
    background-color: #B0B0B0;
}
`, "",{"version":3,"sources":["webpack://./src/style/DeleteConfirmModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC,EAAE,6BAA6B;IACnE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent overlay */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background-color: #ffffff;\n    padding: 20px 30px;\n    border-radius: 8px;\n    width: 400px;\n    text-align: center;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.modal-content h2 {\n    font-size: 20px;\n    color: #FF0000;\n    margin-bottom: 10px;\n}\n\n.modal-content p {\n    font-size: 16px;\n    color: #4B5563;\n    margin-bottom: 20px;\n}\n\n.confirm-button {\n    padding: 10px 20px;\n    background-color: #FF0000;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-right: 10px;\n}\n\n.cancel-button {\n    padding: 10px 20px;\n    background-color: #CCCCCC;\n    color: black;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.confirm-button:hover {\n    background-color: #E60000;\n}\n\n.cancel-button:hover {\n    background-color: #B0B0B0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
